import styled from "styled-components"

export default function OrderInfoRow({ label, value }) {
  return (
    <TableRow>
      <Label>{label}</Label>
      <TableData>{value}</TableData>
    </TableRow>
  )
}

const TableRow = styled.div`
  display: flex;
  padding-bottom: calc(100vw * (16 / 375));

  &:nth-last-child(1) {
    padding-bottom: 0;
  }
`

const Label = styled.span`
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  line-height: calc(100vw * (16 / 375));
  width: calc(100vw * (52 / 375));
  min-width: calc(100vw * (52 / 375));
  max-width: calc(100vw * (52 / 375));
  margin-right: calc(100vw * (17 / 375));
`

const TableData = styled.span`
  font-size: calc(100vw * (14 / 375));
  font-weight: 400;
  line-height: calc(100vw * (20 / 375));
  transform: translateY(calc(100vw * (-2 / 375)));
  white-space: pre-wrap;
`
